import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface HolidayState {
  holidays: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "holidays" | null;
}

const initialState: HolidayState = {
  holidays: null,
  loading: "idle",
  error: null,
  action: null,
};

export const getHolidaysList: any = createAsyncThunk(
  "fetch/holidaysList",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.HOLIDAY.LIST, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const holidaysSlice = createSlice({
  name: "reset",
  initialState: initialState,
  reducers: {
    resetAll: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.holidays = null;
      state.action = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHolidaysList.pending, (state) => {
      state.loading = "pending";
      state.holidays = null;
      state.error = null;
      state.action = "holidays";
    });
    builder.addCase(getHolidaysList.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.holidays = action.payload;
      state.error = null;
      state.action = "holidays";
    });
    builder.addCase(getHolidaysList.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.holidays = null;
      state.action = "holidays";
    });
  },
});

export const { resetAll } = holidaysSlice.actions;
export default holidaysSlice.reducer;
